import { TFilterKey } from '@app.feature/activityFilter/modules/constant'
import { TStoreSlice } from '../storeActivityFilter'

// TODO prettier plugin 관련 버전 이슈
// eslint-disable-next-line prettier/prettier
export type TOrderMapKey = `${TFilterKey}.${string}`

type TOrderMap = {
  [key in TOrderMapKey]: number
}

export type TOrderSlice = {
  order: number
  orderMap: TOrderMap
  getOrderByKey: (orderMapKey: TOrderMapKey) => number
}

const createOrderSlice: TStoreSlice<TOrderSlice> = (set, get) => ({
  order: 0,
  orderMap: {},
  getOrderByKey: (orderMapKey) => {
    const { orderMap } = get()
    return orderMap?.[orderMapKey]
  },
})

export default createOrderSlice
